var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExcle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "excle",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_152",
    "data-name": "Rectangle 152",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x31_19-excel",
    transform: "translate(74.999 40.219)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_405",
    "data-name": "Group 405",
    transform: "translate(-71.999 -36.219)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_404",
    "data-name": "Group 404",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M296.707,97.457h-6.961V99.6h1.607a.537.537,0,0,1,0,1.074h-1.607v1.074h1.607a.537.537,0,0,1,0,1.074h-1.607V103.9h1.607a.537.537,0,0,1,0,1.074h-1.607v1.074h1.607a.537.537,0,0,1,0,1.074h-1.607v2.148h6.961a.536.536,0,0,0,.535-.537V97.994A.536.536,0,0,0,296.707,97.457Zm-2.142,9.665h-1.071a.537.537,0,0,1,0-1.074h1.071a.537.537,0,0,1,0,1.074Zm0-2.148h-1.071a.537.537,0,0,1,0-1.074h1.071a.537.537,0,0,1,0,1.074Zm0-2.148h-1.071a.537.537,0,0,1,0-1.074h1.071a.537.537,0,0,1,0,1.074Zm0-2.148h-1.071a.537.537,0,0,1,0-1.074h1.071a.537.537,0,0,1,0,1.074Z",
    transform: "translate(-279.735 -95.309)",
    fill: "#e62237"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M30.446,39.905a.525.525,0,0,0-.44-.114L21.438,41.4A.535.535,0,0,0,21,41.93V53.742a.536.536,0,0,0,.437.527l8.567,1.611a.511.511,0,0,0,.1.01.536.536,0,0,0,.535-.537V40.319A.536.536,0,0,0,30.446,39.905ZM28.315,50.387a.532.532,0,0,1-.755-.051L26,48.552l-1.366,1.761a.533.533,0,0,1-.423.207.536.536,0,0,1-.423-.867l1.493-1.924-1.473-1.688a.537.537,0,0,1,.05-.757.531.531,0,0,1,.755.051l1.337,1.531,1.586-2.045a.536.536,0,1,1,.845.661L26.671,47.69l1.693,1.94A.537.537,0,0,1,28.315,50.387Z",
    transform: "translate(-21.001 -39.781)",
    fill: "#e62237"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcle);
export default __webpack_public_path__ + "static/media/excle.e9a14f00aa2b13801af05a6e871e1634.svg";
export { ForwardRef as ReactComponent };